import { AfterViewInit, Component, ElementRef, Inject, NgZone, OnInit } from '@angular/core';
import { DataService } from 'src/app/shared/network/data.service';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

import { ImportProgressService } from 'src/app/shared/import/import-progress.service';
import { ImportStep } from 'src/app/shared/import/import-step';
import { ExampleArticleItem } from './example-article-item';
import { GoogleDriveService } from './google-drive.service';
import { NotificationService } from 'src/app/shared/notificaton.service';
import { GoogleSettingsService } from './google-settings.service';

@Component({
    templateUrl: './upload-file.component.html',
    styleUrls: ['../general.scss', './upload-file.component.scss']
})
export class UploadFileComponent implements OnInit, AfterViewInit {
    private googleDriveService: GoogleDriveService;
    fileToUpload: File = null;
    filename: string = '';
    googleDocUrl: string;
    loading = false;
    exampleArticles: ExampleArticleItem[] = undefined;

    constructor(private dataService: DataService, private router: Router, private importProgressService: ImportProgressService, notifier: NotificationService, private ngZone: NgZone,
                @Inject(DOCUMENT) document, elementRef: ElementRef, googleSettingsService: GoogleSettingsService) {
        this.googleDriveService = new GoogleDriveService(notifier, this.filePickedCallback.bind(this), document, elementRef, googleSettingsService);
    }

    ngOnInit(): void {
        this.importProgressService.setStartingImportStep();
        let self = this;
        this.dataService.get<ExampleArticleItem[]>('articles/examples').then(items => {
            self.exampleArticles = items;
        });
    }
    
    ngAfterViewInit(): void {
        this.googleDriveService.addScriptInclude();
    }

    handleFileInput(files: FileList) {
        if (files.length > 0) {
            this.fileToUpload = files.item(0);
            this.filename = files.item(0).name;
        }
    }

    public async uploadFile() {
        if (!this.fileToUpload) {
            return;
        }
        if (this.loading){
            return;
        }
        try {
            this.loading = true;
            let projectId = await this.dataService.postFile('upload', this.fileToUpload);
            this.importProgressService.setImportStep(ImportStep.upload);
            if (this.filename.endsWith('.dwp')) {
                this.router.navigateByUrl('/cards?projectId=' + projectId);
            } else {
                this.router.navigateByUrl('/data-sanity?projectId=' + projectId);
            }
        } finally {
            this.loading = false;
        }
    }

    public googleDocUrlIsValid() {
        return this.googleDocUrl && this.googleDocUrl.startsWith('https://docs.google.com/spreadsheets/d/');
    }

    pickAndDownloadFile() {
        this.googleDriveService.pickAndDownloadFile();
    }

    private filePickedCallback(fileId, accessToken, fileName, mimeType) {
        let self = this;
        this.dataService.post('upload/createFromPrivateGoogleDoc', {
            fileId: fileId,
            accessToken: accessToken,
            fileName: fileName,
            mimeType: mimeType,
        }).then(projectId => {
            self.importProgressService.setImportStep(ImportStep.upload);
            self.ngZone.run(() => {
                if (fileName.endsWith('.dwp')) {
                    self.router.navigateByUrl('/cards?projectId=' + projectId);
                } else {
                    self.router.navigateByUrl('/data-sanity?projectId=' + projectId);
                }
            });
        });
    }
}
